import { h } from 'preact';
import Store from 'store/store';
// import * as actions from 'store/actions';
import FilterOption from './filterOption';
import Filter from './filter';
import { track } from 'utils/tracking';
import pure from 'utils/pure';
import { condClass, parseDate } from 'utils/utils';
import s from 'components/pages/showtimes/filterStyled.sss';

export default @pure class FilterStyled extends Filter {

	focus() {
		track({ a: 'filter_dropdown_opened' });
	}

	blur() {
		track({ a: 'filter_dropdown_closed' });
	}

	alterOptions(options) {
		return options;
	}

	orderOptions(options) {
		const { orderTitlesByDateData } = Store.get().activePage.data;
		let titlesDatesArr = Object.values(orderTitlesByDateData);
		let orderedOptions = [];

		const newOptions = options.map((opt) => {
			let film = titlesDatesArr.find(film => film.movieId === opt.id);
			return {
				...opt,
				date: film ? film.date : ''
			};
		});

		orderedOptions = newOptions.sort(function (a, b) {
			return parseDate(a.date) - parseDate(b.date);
		});

		return orderedOptions;
	}

	render(props) {
		const { filter, multiple, disabled, device, pageData } = props;
		const { orderTitlesByDate, orderTitlesByDateData } = pageData;

		// let allActive = !filter.current || filter.current.length === 0 || filter.current.length === filter.options.length;

		let allOption = { id: 'ALL' };
		allOption[filter.displayProp] = filter.labelAll;
		if (filter.id === 'format' && !filter.labelAll) {
			let disp = filter.displayProp;
			let dispCount = 2;
			// let dispElems = filter.options.slice().sort((a,b) => b[disp].localeCompare(a[disp])).slice(0, dispCount).map(f => f[disp]);
			let dispElems = filter.options.slice(0, dispCount).map(f => f[disp]);
			allOption[disp] = dispElems.join(', ') + (filter.options.length <= dispCount ? '' : '...');
		}

		// let selectedOption = (filter.current.length) > 0 ? filter.current[0] : allOption;
		// let display = !filter.current.length ? allOption[filter.displayProp] : filter.current.map(o => o[filter.displayProp]).join(', ');
		let display = allOption[filter.displayProp];
		if (filter.current.length) {
			let displayed = filter.current.reduce((arr, opt) => {
				let disp = opt[filter.displayProp];
				if (arr.indexOf(disp) === -1) arr.push(disp);
				return arr;
			}, []);
			display = displayed.join(', ');
		}

		let containerClass = s.container + condClass(device === 'desktop', s.desktop) + condClass(filter.id === 'format' || filter.id === 'movie', s.containerLast);
		containerClass += condClass(s[filter.id]);

		let mp = filter.matchProp || 'id';
		let options = filter.options
			.filter(o => !filter.disabled || !filter.disabled.length || !filter.disabled.find(d => o[mp] == d[mp]));

		options = options.reduce((arr, opt) => {
			let display = opt[filter.displayProp] || '';
			let id = opt.id;
			let group = filter.groupProp && opt[filter.groupProp] ? opt[filter.groupProp] : display;
			let existing = arr.find(o => o.group === group);
			if (existing) {
				existing.id += ';;;' + id;
				// Make sure we show the group name
				existing.display = existing.group;
			} else {
				arr.push({ id, display, group });
			}
			return arr;
		}, []);

		if (orderTitlesByDate && orderTitlesByDateData && orderTitlesByDateData.length !== 0) {
			options = this.orderOptions(options).map(o => <FilterOption option={o} display={o.display} />);
		} else {
			options = this.alterOptions(options).map(o => <FilterOption option={o} display={o.display} />);
		}

		let dropdownAriaLabel = 'Select option';

		if (filter.id === 'stDate') {
			dropdownAriaLabel = pageData.selectDayAriaLabel || 'Select day';
		} else if (filter.id === 'timeOfDay') {
			dropdownAriaLabel = pageData.selectTimeAriaLabel || 'Select time';
		} else if (filter.id === 'format') {
			dropdownAriaLabel = pageData.selectFormatAriaLabel || 'Select format';
		}

		return (
			<div class={containerClass}>
				<div class={s.dummy}>{display}</div>
				<select
					class={s.dropdown}
					multiple={multiple}
					ref={(select) => { this.$select = select; }}
					onChange={this.changed.bind(this)}
					value={(filter.current[0] || allOption).id}
					disabled={disabled}
					onClick={this.focus}
					aria-label={dropdownAriaLabel}
				>
					<FilterOption option={allOption} display={allOption[filter.displayProp]} />
					{options}
				</select>
			</div>
		);
	}
}
